module.exports = __webpack_public_path__ + "img/blog-det-bg.8a4aba72.png";